import { LARGE_VIEWPORT } from "../../../state/modules/layout";
import { TILE_SIZES } from "../../../helpers/constants";
import productTileStyles from "../ProductTile.css";
import uponTile from "./uponTileStyle/index.css";
import underneathTile from "./underneathTileStyle/index.css";
import badgesFactory from "./badgesFactory";

const { bottomLeftBadge, bottomRightBadge, underneathBadge } =
  productTileStyles;

const badges = ({ viewportCategory, tileSize }) => {
  const isFeaturedProduct = tileSize !== TILE_SIZES.TILE_SIZE_ONE_BY_ONE;

  const earlyAccessClasses = [
    underneathTile.badge,
    underneathTile.earlyAccessBadge,
    underneathBadge,
  ];

  if (isFeaturedProduct) {
    return {
      underneathTileBadges: badgesFactory({
        earlyAccessClasses,
      }),
    };
  }

  const restockingSoonClasses = [
    underneathTile.badge,
    underneathTile.restockingSoon,
    underneathBadge,
  ];

  if (viewportCategory !== LARGE_VIEWPORT) {
    return {
      uponTileBadges: badgesFactory({
        productClasses: [uponTile.productBadge, bottomLeftBadge],
        sellingFastClasses: [uponTile.sellingFastBadge, bottomRightBadge],
      }),
      underneathTileBadges: badgesFactory({
        earlyAccessClasses,
        restockingSoonClasses,
      }),
    };
  }

  return {
    underneathTileBadges: badgesFactory({
      earlyAccessClasses,
      restockingSoonClasses,
      productClasses: [
        underneathTile.badge,
        underneathTile.productBadge,
        underneathBadge,
      ],
      sellingFastClasses: [
        underneathTile.badge,
        underneathTile.sellingFastBadge,
        underneathBadge,
      ],
    }),
  };
};

export default badges;
